export class DocumentRestoreFolderModel {
  documentFolderId: string;
  documentId: string;
}

export class DocumentRestoreModel {
  patientId: string;
  type: number;
  // Used for patient folder restore
  documentIds: string[];
  // Used for Library / Lectore folders restore to location
  documentFolderId: string;
  // Used for Library / Lecture standard restore
  mode: string = 'standard';  // standard / specific
  documentInFolders: DocumentRestoreFolderModel[] = [];
}
